export enum KycUserFlow {
  creditLineOnlineWithdrawal = "creditLineOnlineWithdrawal",
  creditLineCardRequest = "creditLineCardRequest",
  creditLineCashWithdrawal = "creditLineCashWithdrawal",
  creditLineCardActivation = "creditLineCardActivation",
  creditCardShowPin = "creditCardShowPin",
  creditLineDefrostWithdrawal = "creditLineDefrostWithdrawal",
}

export enum KycValidations {
  nationalIdLastFourCharacters = "nationalIdLastFourCharacters",
}
